import { store } from "../redux/store";
import { getProductId, getProductType } from "../utils/storage";

// UTM Source URL
export const utmSourceURL = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const query = queryParams.get("utm_source") || getReferrerValue();

  if (query) {
    localStorage.setItem("utm_source", query);
    return `?utm_source=${query}`;
  } else {
    return "";
  }
};

// UTM Source Storage
export const utmSourceStorage = () => {
  const source = localStorage.getItem("utm_source");

  if (source) {
    return `?utm_source=${source}`;
  } else {
    return "";
  }
};

// Add Customer Type & App Version
export const storeCustomerTypeAndAppVersion = (customerType, appVersion) => {
  if (customerType && appVersion) {
    localStorage.setItem("customerType", customerType);
    localStorage.setItem("appVersion", appVersion);
  }
};

// Generate or Create Session ID
export const generateSessionId = () => {
  const instanceId = crypto.randomUUID(); // Generates a unique web ID
  const timestamp = Date.now(); // Current timestamp in ms
  const sessionId = `${instanceId}_${timestamp}`;
  return sessionId;
};

// Convert User Type
export const convertUserType = () => {
  let userType = localStorage.getItem("customerType");
  if (userType) {
    return userType.toLowerCase().replace(/\s+/g, "_");
  }
  return "";
};

// Set Product Name by ID
export const setProductNameByID = () => {
  const productId = Number(getProductType());
  const productMap = {
    1: "emi",
    2: "payday",
  };
  return productMap[productId] || "";
};

// Loan Type for Analytics
export const setLoanType = () => {
  const productId = Number(getProductId());
  const productMap = {
    1: "emi",
    2: "payday",
  };
  return productMap[productId] || "";
};

export const setBucketValue = (value) => {
  if (value >= 0 && value <= 10000) {
    return 0;
  } else if (value >= 10001 && value <= 25000) {
    return 1;
  } else if (value >= 25001 && value <= 50000) {
    return 2;
  } else if (value >= 50001 && value <= 75000) {
    return 3;
  } else if (value >= 75001 && value <= 100000) {
    return 4;
  } else if (value >= 100001 && value <= 150000) {
    return 5;
  } else if (value >= 150001 && value <= 200000) {
    return 6;
  } else if (value >= 200001) {
    return 7;
  }

  return null;
};

export const getVisitType = () => {
  let visitType = localStorage.getItem("visitType");

  if (visitType) {
    return "repeat";
  } else {
    localStorage.setItem("visitType", "true");
    return "first";
  }
};

function getReferrerValue() {
  const query = window.location.search.substring(1);
  const referrerParam = query.split("&").find((param) => param.startsWith("referrer-"));

  return referrerParam?.split("referrer-")[1] ?? "";
}

export async function checkCameraPermission() {
  try {
    const result = await navigator.permissions.query({ name: "camera" });

    // "granted" | "denied" | "prompt"
    return result.state;
  } catch (err) {
    console.error("Permissions API not supported:", err);
  }
}

export const getUpdatedCustomerID = () => {
  const reduxID = store.getState().user?.user?.customerID;
  const storageID = localStorage.getItem("customerID");

  const id = reduxID ?? storageID;

  return Number(id);
};
